export default __webpack_public_path__ + "src/assets/info-small.7c07d6e22c7287e4d4c648e0a88f2b6f.svg";